import styled from 'styled-components';

export const Logo = () => {
  return (
    <LogoWrapper>
      <LogoImg src="/logo.webp" />
      <span>Popup Games</span>
    </LogoWrapper>
  );
};

const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 32px;
  font-size: 16px;
  font-weight: 500;
  color: #3b45cc;
`;

const LogoImg = styled.img`
  width: 32px;
  height: 32px;
  margin-right: 12px;
  border-radius: 8px;
`;
